import { render, staticRenderFns } from "./Icons_information_component.vue?vue&type=template&id=734590f2&scoped=true&"
var script = {}
import style0 from "./Icons_information_component.vue?vue&type=style&index=0&id=734590f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734590f2",
  null
  
)

export default component.exports